module.exports = __webpack_public_path__ + "static/media/FH12.a1a81ea7.png";